// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseAdminFactory instead of class inheritance

import { createBaseAdmin, type IBaseAdmin } from "../BaseAdminFactory";
import type { Deed } from "le-coffre-resources/dist/Admin";
import type { QueryPayload } from "../../../types";
import type { IGetDeedsParams } from "./Deeds";

interface DeedsInstance {
	get(q: IGetDeedsParams): Promise<Deed[]>;
	getByUid(uid: string, q?: QueryPayload): Promise<Deed>;
}

// Module-level singleton instance
let instance: DeedsInstance | null = null;
let baseAdminInstance: IBaseAdmin | null = null;

function createDeeds(): DeedsInstance {
	if (!baseAdminInstance) {
		baseAdminInstance = createBaseAdmin();
	}

	const baseAdmin = baseAdminInstance;
	const baseUrl = baseAdmin.namespaceUrl.concat("/deeds");

	return {
		get: async (q: IGetDeedsParams): Promise<Deed[]> => {
			const url = new URL(baseUrl);
			baseAdmin.appendJsonSearchParams(url, { q });
			try {
				return await baseAdmin.getRequest<Deed[]>(url);
			} catch (err) {
				baseAdmin.onError(err);
				return Promise.reject(err);
			}
		},
		getByUid: async (uid: string, q?: QueryPayload): Promise<Deed> => {
			const url = new URL(baseUrl.concat(`/${uid}`));
			if (q) {
				baseAdmin.appendJsonSearchParams(url, q);
			}
			try {
				return await baseAdmin.getRequest<Deed>(url);
			} catch (err) {
				baseAdmin.onError(err);
				return Promise.reject(err);
			}
		},
	};
}

export function getDeedsInstance(): DeedsInstance {
	if (!instance) {
		instance = createDeeds();
	}
	return instance;
}
